import axios from 'axios';
import type { AxiosResponse } from 'axios';

function getEndpointPath(): string {
  return `/api/v1/activation/product_tour/users`;
}

type Error = {
  response: AxiosResponse;
};

export async function addUserToDemoSite(): Promise<{ success: boolean }> {
  try {
    const response = await axios.post(getEndpointPath());

    return { success: response?.status === 201 };
  } catch (error) {
    // catch error and return success if already added to demosite
    if ((error as Error)?.response?.status === 409) {
      return { success: true };
    }
    throw error;
  }
}

export async function removeUserFromDemoSite(): Promise<{ success: boolean }> {
  const response = await axios.delete(getEndpointPath());

  return { success: response?.status === 204 };
}
